import { Config } from 'config';

const origins = Config.CURRENT_ORIGINS;

export type ApiPathsType = (typeof ApiPaths)[keyof typeof ApiPaths];

export const ApiPaths = {
  AA_CHANGE_REQUESTS: `${origins.SM}/AaChangeRequests`,
  AA_RCPS: `${origins.SM}/aaRcps`,
  ACCOUNT_MARKET_PLACES: `${origins.SM}/accountMarketplaces`,
  ACCOUNTS: `${origins.SM}/accounts`,
  BDBS: `${origins.SM}/bdbs`,
  BDB_METRICS: `${origins.SM}/bdbmetrics`,
  BILLINGS: `${origins.SM}/billings`,
  BILLING_SERVICE_PROXY: `${origins.SM}/billingService`,
  BILLING_SERVICE: `${origins.BILLING}/billing`,
  CLOUD_ACCOUNTS: `${origins.SM}/cloudAccounts`,
  TGW_RCPS: `${origins.TGW}/rcps`,
  AA_TGW_RCPS: `${origins.TGW}/aaRcps`,
  PRIVATE_LINKS: `${origins.PRIVATE_LINK}/rcps`,
  AA_PRIVATE_LINKS: `${origins.PRIVATE_LINK}/aaRcps`,
  CLUSTER_ROLES: `${origins.SM}/clusterRoles`,
  CLUSTER_USERS: `${origins.SM}/clusterUsers`,
  CLUSTERS: `${origins.SM}/clusters`,
  COUPONS: `${origins.SM}/coupons`,
  CRDBS: `${origins.SM}/crdbs`,
  CSRF: `${origins.SM}/csrf`,
  LOGIN: `${origins.SM}/login`,
  MFA: `${origins.SM}/mfa`,
  MODULES: `${origins.SM}/modules`,
  MW_SUBSCRIPTION: `${origins.MW}/subscription`,
  MW_ACCOUNT: `${origins.MW}/account`,
  MW_DATABASE: `${origins.MW}/database`,
  OFFBOARDING: `${origins.KYC}/offboarding`,
  OFFBOARDING_SM: `${origins.SM}/offboarding`,
  PAAS_EMAILS: `${origins.SM}/paas-emails`,
  PARAMETERS: `${origins.SM}/parameters`,
  PAYMENT_INFOS: `${origins.SM}/paymentInfos`,
  PLANS: `${origins.SM}/plans`,
  PROVIDERS: `${origins.SM}/providers`,
  RCPS: `${origins.SM}/rcps`,
  REDIS_ACLS: `${origins.SM}/redisAcls`,
  SAML: `${origins.SM}/saml`,
  SESSION_LOGS: `${origins.SM}/sessionLogs`,
  SETUP_COMPLETENESS: `${origins.KYC}/setup-completeness`,
  SHARD_TYPE_PRICINGS: `${origins.SM}/shardTypePricings/calculator/versioned`,
  SHARD_TYPES: `${origins.SM}/shardTypes`,
  SHARDS_USAGE_REPORTS: `${origins.SM}/shardsUsageReports`,
  SLOW_LOGS: `${origins.SM}/slowlogs`,
  SUBSCRIPTION_MINIMAL_PRICINGS: `${origins.SM}/subscriptionMinimalPricings/versioned`,
  SUBSCRIPTIONS: `${origins.SM}/subscriptions`,
  SYSTEM_LOGS: `${origins.SM}/systemLogs`,
  USAGE_REPORTS: `${origins.SM}/usageReports`,
  USERS: `${origins.SM}/users`,
  COST_REPORT: `${origins.SM}/costReport`,
  BDB_PACKAGES: `${origins.SM}/bdb_packages`,
  REDIS_VERSIONS: `${origins.SM}/redis-versions`,
  REDIS_FEATURES: `${origins.SM}/redis-versions/features`,
  PERSISTENCE_ENCRYPTION_KEY: `${origins.SM}/persistence-encryption-keys`,
  METRICS: `${origins.METRICS}/cloud-metrics-service`
} as const;

// ************************************************************
// Typescript check to verify that ApiPathsType is not a string
// If you get a type error here then check your changes to ApiPaths
// ************************************************************
const TypeCheckResult = (typeof {} as string extends ApiPathsType ? '' : string) === 'string'; // eslint-disable-line @typescript-eslint/no-unused-vars
